<template>
    <modal v-bind="$attrs" v-on="$listeners">
      <template v-slot:title>
        <h1>
            {{ $t('organization_profile.view_dummy_email_credential_modal.dummy_email_credential') }}
        </h1>
      </template>
      <template v-slot:body>
        <el-form class="auth-form" >
          <div class="form-row">
            <elsa-input name="email" :label="$t('organization_profile.view_dummy_email_credential_modal.email_label')" class="email" v-model.lazy="dummyEmailCredential.email" readonly>
              {{ $t('organization_profile.view_dummy_email_credential_modal.email_label') }}
            </elsa-input>
            <elsa-input name="password" :label="$t('organization_profile.view_dummy_email_credential_modal.password_label')" class="password"  v-model.lazy="dummyEmailCredential.password" readonly>
              {{ $t('organization_profile.view_dummy_email_credential_modal.password_label') }}
            </elsa-input>
          </div>
        </el-form>
      </template>
      <template v-slot:footer> </template>
    </modal>
  </template>
  
  <script>
  import Modal from '@/components/common/Modal'
  import ElsaInput from '@/components/common/Input'

  export default {
    components: {
      Modal,
      ElsaInput
    },
    props: {
      dummyEmailCredential: {
        email: '',
        password: ''
      }
    }
  }
  </script>
  
<style lang="scss" scoped>
  ::v-deep .el-form .el-form-item .el-form-item__label {
    text-transform: capitalize;
  }
  .auth-form {
    .form-row {
      display: flex;
      .email,
      .password {
        width: 50%;
      }
      .email {
        margin-right: 30px;
      }
    }
  }
</style>
 
  
  